export type ActiveProject = {
  id: string;
  platformProjectId: string | null;
};

let activeProject: ActiveProject | null = null;

export const setActiveProject = (project: ActiveProject | null): void => {
  activeProject = project;
};

export const getActiveProject = (): ActiveProject | null => {
  return activeProject;
};
